import { PersonAnalysisOceanLabels } from '@aibees/elephant/types/personality-analysis';
import { SxStyleThemeValueFunc } from '@aibees/shared/theme';
import type { ButtonProps } from '@mui/material';

export const colorMap: Record<
  PersonAnalysisOceanLabels,
  {
    backgroundColor: string | SxStyleThemeValueFunc;
    labelColor: string | SxStyleThemeValueFunc;
    color: ButtonProps['color'];
  }
> = {
  [PersonAnalysisOceanLabels.A]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.warning[500],
    color: 'warning',
  },
  [PersonAnalysisOceanLabels.a]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.warning[500],
    color: 'warning',
  },
  [PersonAnalysisOceanLabels.E]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.grey[500],
    color: 'default',
  },
  [PersonAnalysisOceanLabels.e]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.grey[500],
    color: 'default',
  },
  [PersonAnalysisOceanLabels.N]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.success[700],
    color: 'success',
  },
  [PersonAnalysisOceanLabels.n]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.success[700],
    color: 'success',
  },
  [PersonAnalysisOceanLabels.O]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.primary[600],
    color: 'primary',
  },
  [PersonAnalysisOceanLabels.o]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.primary[600],
    color: 'primary',
  },
  [PersonAnalysisOceanLabels.C]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.error[600],
    color: 'error',
  },
  [PersonAnalysisOceanLabels.c]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.error[600],
    color: 'error',
  },
};
